import { useStoreState, useStoreActions } from 'easy-peasy';
import { useQuery } from 'react-query';

import { Config } from '@ge/shared/data-hooks';
import { getSimilarCaseDetails } from '@ge/feat-monitor/services';

import { CasesQueryKeys } from './cases/query-keys';

export const useCaseDetailData = ({ caseId, enabled = true }) => {
  const { fetchCaseWithDetails } = useStoreActions((actions) => actions.cases);
  const getEntityPanelCase = useStoreState((state) => state.cases.getEntityPanelCase);

  const getCaseDetails = useQuery(
    CasesQueryKeys.detail(caseId),
    () => fetchCaseWithDetails(caseId),
    {
      enabled: enabled && Boolean(caseId),
      ...Config.EXECUTE_ONCE,
    },
  );

  const caseWithDetails = getEntityPanelCase(caseId);

  return { caseWithDetails, ...getCaseDetails };
};

export const useSimilarCalmCaseData = ({caseId, analyticSource}) => {
   const queryResult = useQuery(
    ['similar-calm-case', caseId],
    () => getSimilarCaseDetails(caseId),
    {
      enabled: Boolean(caseId) && analyticSource == 'CALM',
      ...Config.TASKS_REFRESH,
      staleTime: 0,
      retry: 3,
      retryDelay: 1000,
    }
  );

  return {
    data: queryResult.data,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error,
    refetch: queryResult.refetch
  };
};
